<div class="row container-style">
  <div class="col-12 col-sm-12">
    <div class="row">
      <div class="custom-container col-lg-4 col-md-4 col-sm-9 col-12">
        <label class="fw-bolder">Sucursal</label>
        <p>{{branchName}}</p>
      </div>
      <div class="custom-container col-lg-2 col-md-2 col-sm-3 col-12">
        <label class="fw-bolder">Consecutivo</label>
        <p>{{subrentalEntryModel.consecutive}}</p>
      </div>
      <hr>
    </div>
    <div class="row mb-3">
      <div class="col-12 col-md-12">
        <label>Para realizar el proceso de importación del detalle de la entrada, descargue la guía y siga los
          pasos:</label>
      </div>
    </div>
    <div class="row">
      <div class="col-3 col-md-3">
        <app-custom-button [title]="'downloadGuideImport'" [label]="'Descargar Guía'" [severity]="'success'"
          [width]="'9.5rem'" (onClick)="downloadGuideImport()"></app-custom-button>
      </div>
      <div class="col-9 col-md-9 d-flex justify-content-end">
        <div class="d-flex gap-2">
          <input type="file" id="fileImport" (change)="getNameFile($event)"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" hidden />
          <app-custom-button [title]="'Seleccionar archivo'" [label]="'Seleccionar archivo'" [width]="'8.5rem'"
            (onClick)="attachFileImport()"></app-custom-button>
          <p class="ms-2 mt-2">{{nameFile}}</p>
          <app-custom-button [title]="'Importar'" [label]="'Importar'" [variant]="undefined"
            (onClick)="importSubrentalEntry()"></app-custom-button>
        </div>
      </div>
    </div>
    <div class="row">
      <div id="list" *ngIf="visibleTxt">
        <h6>Lista de Errores y Alertas</h6>
        <p>Total errores: {{subrentalEntryAlerts.length}}</p>
        <div id="container-alerts" *ngFor="let subrentalEntryAlert of subrentalEntryAlerts">
          <p [ngClass]="errorSubrentalEntry == 1 ? 'message-error' : 'message-alert'">
            {{subrentalEntryAlert.message}}
          </p>
        </div>
      </div>
      <div class="row" *ngIf="visibleTxt">
        <div class="d-flex justify-content-end">
          <app-custom-button [title]="'Exportar'" [label]="'Exportar'" [icon]="'pi pi-file-export'" [width]="'5.5rem'"
            (onClick)="downloadErrorsTxt()"></app-custom-button>
        </div>
      </div>
    </div>
  </div>
</div>